<div class="h-100">
    <div class=" w100 row-flex">
        <mat-card-title>Categories</mat-card-title>
        <button [mat-dialog-close]="true" aria-label="Close categories dialog" class="right" color="primary" mat-icon-button>
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <div class="h-100">
        <div class="add-line">
            <mat-form-field class="example-chip-list">
                <input (blur)="add($event, 'categoryControl')" (keydown.Enter)="add($event, 'categoryControl')"
                       *ngIf="!selectedChip"
                       [matChipInputAddOnBlur]="addOnBlur"
                       [matChipInputFor]="categoryChipList"
                       matInput placeholder="Enter category here" id="categoryField">
                <mat-error *ngIf="duplicate" class="error">That category already exists.</mat-error>
            </mat-form-field>
            <button (click)="add($event, 'categoryControl')" aria-label="add button" class="add-button" color="primary"
                    mat-icon-button>
                <mat-icon>add_circle</mat-icon>
            </button>
        </div>
        <mat-card class="card">
            <mat-chip-list #categoryChipList class="mat-chip-list-stacked chip-list" name="categoryControl">
                <mat-chip (removed)="remove(category,'categoryControl')" *ngFor="let category of categories; let i = index"
                          [disabled]=false
                          [removable]="removable" [selectable]="selectable" class="list-chip" id="removeChip{{i}}">
                    {{category.name}}
                    <mat-icon *ngIf="removable" matChipRemove>cancel</mat-icon>
                </mat-chip>
            </mat-chip-list>
            <mat-list *ngFor="let gName; let i = index" id="gNameField{{i}}">
                <mat-list-item> {{ gName }} </mat-list-item>
            </mat-list>
        </mat-card>
    </div>
</div>
